import useSWR from 'swr';

// Libs
import { categoryInfos } from '@/lib/home/categoryInfos';

import { get } from '@/utils/client';
import { ONBOARDING_TASKS } from '@/routes/apiEndpoints';

// Types
import type { AxiosError } from 'axios';
import type { KeyedMutator, SWRConfiguration } from 'swr';
import { onboardingTasks } from '@/lib/onboardingTasks/tasks';

export type MutateTasksType = KeyedMutator<TaskType[]>;

export type TaskType = {
    id: number;
    slug: string;
    category: keyof typeof categoryInfos;
    priority: 1 | 2;
    completed_at: string;
};

const useOnboardingTasks = (options?: SWRConfiguration<TaskType[], AxiosError<Error>>) => {
    const {
        data,
        mutate: mutateTasks,
        error: tasksError,
        isLoading
    } = useSWR<TaskType[], AxiosError<Error>>(
        ONBOARDING_TASKS,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    let tasks = [];
    if (data) {
        // Don't display tasks that are not in onboardingTasks array
        const tasksSlugs = Object.keys(onboardingTasks);
        tasks = data?.filter((task) => (tasksSlugs as unknown as string).includes(task.slug));

        // if batch of 4 tasks are completed, we put them at the end of the list
        const notCompletedTasks = tasks.filter((task) => task.completed_at === null);
        let isSorting = notCompletedTasks.length === 0 ? false : true;
        while (isSorting) {
            [0, 1, 2, 3].forEach((number) => {
                if (tasks[number].completed_at === null) {
                    isSorting = false;
                }
            });
            if (isSorting) {
                [0, 1, 2, 3].forEach(() => {
                    tasks.push(tasks.shift());
                });
            }
        }
    }

    return {
        tasks,
        countTasksComplete: tasks?.filter((task) => task.completed_at !== null)?.length ?? 0,
        countTasks: tasks?.length ?? 0,
        mutateTasks,
        tasksError,
        isLoading
    };
};
export default useOnboardingTasks;
